import { render, staticRenderFns } from "./RankFeeds.vue?vue&type=template&id=200a4d27&"
import script from "./RankFeeds.vue?vue&type=script&lang=js&"
export * from "./RankFeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports